import React from 'react';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { useForm, Field } from 'react-final-form';

const DeleteButton = withStyles({
  root: {
    color: '#dc004e',
    borderColor: '#dc004e',
  },
  label: {
  },
})(Button);

export default ({ record, source, withDelete = false }) => {
  const form = useForm();
  const [deleted, setDeleted] = React.useState(false);

  const onImageDelete = () => {
    form.batch(() => {
      form.change(source, null);
    });
    setDeleted(true);
  }

  if (withDelete && record[source] && !deleted)
    return (
      <>
        <img width={130} src={record[source]} alt='Preview' style={{ marginBottom: 10 }} />
        <br/>
        <Field name={source}>{()=>null}</Field>
        <DeleteButton variant="outlined" onClick={onImageDelete}>
          Delete Photo
        </DeleteButton>
      </>
    );
  if (record[source] && !deleted)
    return <img width={130} src={record[source]} alt='Preview' style={{ marginBottom: 10 }} />;
  return null;
};
